import { configureStore } from "@reduxjs/toolkit";
import SuscriptionSlice from "./feature/SuscriptionSlice"
import RegionSlice from "./feature/RegionSlice";
import CloudSlice from "./feature/CloudSlice";
import NameSlice from "./feature/NameSlice";
import TenantSlice from "./feature/TenantSlice";
import planSlice from "./feature/planSlice";
import NametenantSlice from "./feature/NametenantSlice";
import ListPermissionSlice from "./feature/ListPermissionSlice";
import InstanceSlice from "./feature/InstanceSlice";
import VrfSlice from "./feature/VrfSlice";
import ConnectorSlice from "./feature/ConnectorSlice";
import FlagSlice from "./feature/FlagSlice";

export const store = configureStore({
    reducer:{
        SuscriptionSlice,
        RegionSlice,
        CloudSlice,
        NameSlice,
        TenantSlice,
        planSlice,
        NametenantSlice,
        ListPermissionSlice,
        InstanceSlice,
        VrfSlice,
        ConnectorSlice,
        FlagSlice
    }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch